window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  // if (!$(config.recoverPasswordForm).length) {
  //   return;
  // }

  // checkUrlHash();
  resetPasswordSuccess();

  // $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  // $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


var grid = new Object();
grid.maxPage = 0;
grid.currentPage = 0;
grid.currentCategory = 0;
grid.currentURL = "";
grid.loadingPage = false;
grid.currentOrderBy = "";
grid.currentOrder = "";

function load_intro() {
  $("#header, #content, #sidebar-left").addClass("intro");
}

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split("&");
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

function loadGridContent(data) {
  window.history.pushState(
    grid,
    "cruvoir - Category " + grid.currentCategory + " Page " + grid.currentPage,
    grid.currentSidebarURL
  );

  // unload old content
  // $('#content .product-grid').css({transform: 'translateY(24px)', opacity: 0}).on('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
  //if (e.originalEvent.propertyName == 'transform') {
  var that = $("#content .product-grid");
  $(that).off("transitionend webkitTransitionEnd oTransitionEnd");

  $(that).html();

  $(that).replaceWith(data).hide();
  $(that).show().fadeIn();

  // $(that).css({transform: 'translateY(0px)', opacity: 1});
  //}
  //});
}

function appendGridContent(data) {
  $("#content .product-grid").append(data);
}

function openNewGrid(cid, page, base_url, orderby, orderway) {
  var url = base_url || "/" + cid + "-ajax";

  if (cid == 0) {
    // homefeatured
    url = "/modules/homefeatured/ajax.php?ajax=1&shop=1";
  }

  url = updateQueryStringParameter(url, "ajax", "1");
  url = updateQueryStringParameter(url, "p", page);
  // url = updateQueryStringParameter(url, 'shop', $('body').data('shop'));
  grid.currentURL = url;

  grid.currentOrderBy = orderby;
  grid.currentOrderWay = orderway;

  console.info(url);

  $("#content .product-grid").html("");
  var body = $("html, body").scrollTop(0);

  //$('#content .product-grid').animate({transform: 'translateY(24px)', opacity: 0}, function() {
  $("#page-wrap .logo-spinner").addClass("active");
  //});

  updateSidebar(cid);

  if (is_mobile()) {
    $(".sidebar").removeClass("open");
  }

  $.ajax(url)
    .done(function(data, textStatus) {
      console.info("done!");

      grid.currentCategory = cid;
      // updateSidebar(cid);
      loadGridContent(data);
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.info("fail!");
      if (jqXHR.responseText.slice(0, 4) == "<div") {
        grid.currentCategory = cid;
        // updateSidebar(cid);
        loadGridContent(jqXHR.responseText);
      }
    })
    .always(function() {
      $("#page-wrap .logo-spinner").removeClass("active");
    });
}

function updateSidebar(newCategory) {
  var $oldActive = $(".sidebar .active");
  var $newActive = $(".sidebar a[data-category=" + newCategory + "]");

  if ($oldActive[0] == $newActive[0]) {
    return;
  }

  if ($oldActive.length > 0) {
    // deactivate old item
    $oldActive.addClass("deactivated");
    setTimeout(function() {
      $oldActive.removeClass("active");
      $(".sidebar .deactivated").removeClass("deactivated");
    }, 500);

    if ($oldActive.parent().parent()[0] != $newActive.parent().parent()[0]) {
      // Different branch!
      $oldActive.parents(".dropdown.open").each(function() {
        var $title = $(this).find(".title").first();
        console.info("checking parent", $title.text());

        var check = $.contains(this, $newActive[0]);
        console.info(check);

        if (!check) {
          $title[0].click();
        }
      });
    }
  }

  // close others
  var $parent = $newActive.parents(".dropdown").first();
  $parent.parents(".sidebar").find(".dropdown.open").each(function() {
    if (this == $parent[0]) {
      return;
    }
    console.info("Checking ", $(this).text(), $parent.text());
    var check = $.contains(this, $parent[0]);
    console.info(check);
    if (!check) {
      $(".title", this).first()[0].click();
    }
  });

  // Open dropdown if not already open
  $newActive.parent().parent().addClass("open");
  $newActive.addClass("active");

  // SORTING
  $(".sidebar a[data-orderby].active")
    .addClass("deactivated")
    .removeClass("active");
  if (grid.currentOrderBy != "" && grid.currentOrderWay != "") {
    $('.sidebar a[data-orderby="' + grid.currentOrderBy + '"]')
      .filter('a[data-orderway="' + grid.currentOrderWay + '"]')
      .removeClass("deactivated")
      .addClass("active");
  }
}

function revealProducts() {
  $(".product-grid article.product.hidden img").each(function() {
    $(this).attr("src", $(this).data("src"));
  });
  $(".product-grid article.product.hidden").removeClass("hidden");
}

function is_mobile() {
  return window.innerWidth <= 1000;
}

function load_sidebar() {
  $(".sidebar .title").each(function() {
    $(this).prepend('<i class="fa fa-caret-right"></i>');
  });

  $(".sidebar .dropdown .title").click(function() {
    var $parent = $(this).parent();
    $parent.toggleClass("open");

    if ($parent.is(".open")) {
      // var h = $('.submenu', $parent).first().css('height', 'auto').height();
      // $('.submenu', $parent).first().css('height', 0).height(h).css('height', 'auto');
      // $('.submenu', $parent).first().stop().slideDown(366, $.bez([0.55, 0.44, 0.11, 1.18]));
      $(".submenu", $parent).first().stop().slideDown(300);
    } else {
      // $('.submenu', $parent).first().css('height', 0);
      // $('.submenu', $parent).first().stop().slideUp(366, $.bez([0.55, 0.44, 0.11, 1.18]));
      $(".submenu", $parent).first().stop().slideUp(300);
    }
  });

  /*$('.sidebar a[data-category]').click(function(e) {
		if (grid === undefined || grid.currentCategory === 0) {
			// currently not in a grid. just open the link
			return;
		}

		e.preventDefault();

		var cid = parseInt($(this).data('category'));

		if (cid != grid.currentCategory) {
			grid.currentSidebarURL = $(this).attr('href');
			openNewGrid(cid, 1, grid.currentSidebarURL);
		}
	});*/

  $(".sidebar .back-title").click(function(e) {
    e.preventDefault();

    $(this)
      .parents(".parent.open")
      .first() /*.stop().slideUp(366, $.bez([0.55, 0.44, 0.11, 1.18]))*/
      .removeClass("open");
  });

  // Sorting
  /*$('.sidebar a[data-orderby]').click(function(e) {
		if (grid === undefined || grid.currentCategory === 0) {
			// currently not in a grid. just open the link
			return;
		}

		e.preventDefault();

		var by = $(this).data('orderby');
		var way =  $(this).data('orderway');

		if (by != grid.currentOrderBy && way != grid.currentOrderWay) {
			grid.currentSidebarURL = $(this).attr('href');
			openNewGrid(grid.currentCategory, 1, grid.currentSidebarURL, by, way);
		}		
	});*/

  // Open sidebar menus for active items
  $(".sidebar a.active").each(function() {
    console.info(
      "opening: ",
      $(".title:first", $(this).parents(".dropdown").not(".open"))
    );
    $(".title:first", $(this).parents(".dropdown").not(".open")).click();
  });

  // Open sidebar on mobile
  $("header .sidebar-trigger").click(function(e) {
    e.preventDefault();
    $("#sidebar-left").toggleClass("open");
    $("body").toggleClass("sidebar-open", $("#sidebar-left").is(".open"));
  });
}

function load_ui() {
  $("select")
    .wrap('<div class="select-wrap"></div>')
    .after('<i class="arrow-down"></i>')
    .change(function() {
      console.info($(this).val());
      if ($(this).val() == "") {
        $(this).addClass("empty");
      } else {
        $(this).removeClass("empty");
      }
    });
}

function load_product_gallery() {
  function updateMaxWidths() {
    $(this).css("max-width", $(this)[0].naturalWidth);
  }

  $(".product-gallery img").each(updateMaxWidths).load(updateMaxWidths);
  $(".product-gallery img").click(function() {
    var $gallery = $(this).parent();
    var isActive = $(this).is(".active");

    if ($gallery.is(".zoomed")) {
      $("img", $gallery).removeClass("active");
    }
    if (isActive) {
      $(this).removeClass("active");
      $gallery.removeClass("zoomed");
    } else {
      $(this).addClass("active");
      $gallery.addClass("zoomed");
    }
  });

  $('#cart-form select[name="id_attribute"]').change(function() {
    $("#idCombination").val($("option:selected", this).data("prod-attribute"));
  });
}

function load_grid() {
  if ($(".product-grid").length > 0) {
    grid.maxPage = parseInt($(".product-grid").data("maxpage"));
    grid.currentPage = 1;

    if (page_name == "index") {
      grid.currentURL = baseUri + "modules/homefeatured/ajax.php";
    } else if (page_name == "category") {
      grid.currentCategory = $(".product-grid").data("category");
      grid.currentURL = baseUri + grid.currentCategory + "-ajax";
    } else {
      console.info("unknown page_name: " + page_name);
    }

    grid.currentURL = updateQueryStringParameter(grid.currentURL, "p", 1);
    // grid.currentURL = updateQueryStringParameter(grid.currentURL, 'shop', 1);
    grid.currentURL = updateQueryStringParameter(grid.currentURL, "ajax", 1);
  } else {
    grid = undefined;
    return;
  }

  /*$(document).on('click', '.product-grid .pagination a', function(e) {
		e.preventDefault();
		grid.currentURL = $(this).attr('href');
		grid.currentSidebarURL = $(this).attr('href');
		openNewGrid(grid.currentCategory, $(this).data('page'), grid.currentURL);
	});*/

  $(window).scroll(function() {
    // more products?
    if ($(window).scrollTop() > $("body").height() / 2) {
      revealProducts();
    }
  });

  if (window.innerHeight <= document.body.clientHeight) {
    revealProducts();
  }
}

function load_auth() {
  $("form.register").submit(function(e) {
    var pass1 = $("#passwd1").val();
    var pass2 = $("#passwd2").val();

    if (pass1 != pass2) {
      alert("Password mismatch.");
      e.preventDefault();
      return;
    }

    $('input[name="passwd"]').val(pass1);
  });
}

function load_checkout() {
  $("#addressesAreEquals").change(function() {
    if ($(this).is(":checked")) {
      $("#address_invoice").fadeOut();
    } else {
      $("#address_invoice").fadeIn();
    }
  });

  $(".payment-choice .choice input").change(function() {
    if ($("#choice-braintree").is(":checked")) {
      $("#HOOK_PAYMENT .braintree_module").fadeIn();
    } else {
      $("#HOOK_PAYMENT .braintree_module").fadeOut();
    }
  });
}

function load_footer() {
  $("footer .social select").change(function() {
    var val = $(":selected", this).val();
    $("footer .social ." + val)[0].click();
  });

  $("#newsletter-form").submit(function(e) {
    if ($("body").is(".logged")) {
      return;
    }

    e.preventDefault();
    window.location.href =
      "/authentication?email=" +
      $('input[name="email"]', this).val() +
      "#register";
  });
}

function load_header() {
  $("header .currency-list, .sidebar .currency-list").change(function() {
    var currency = $(":selected", this).val();
    var url = updateQueryStringParameter(
      window.location.href,
      "id_new_currency",
      currency
    );
    window.location.href = url;
  });
}

function load_account() {
  /*
	$('.sidebar-account a, .sidebar-cms a').click(function(e) {
		if ($(this).is('.no-ajax')) {
			return;
		}
		e.preventDefault();

		var url = updateQueryStringParameter($(this).attr('href'), 'ajax', 1);
		var $activeItem = $(this);
		var $sidebar = $(this).parents('.sidebar');
		var $parent = $(this).parents('.dropdown').first();

		// close others
		$parent.parents('.sidebar').find('.dropdown.open').each(function() {
			if (this == $parent[0]) {
				return;
			}
			console.info('Checking ', $(this).text(), $parent.text());
			var check = $.contains(this, $parent[0]);
			console.info(check);
			if (!check) {
				$('.title', this).first()[0].click();
			}
		});		

		$('#content section.content-block').addClass('disappearing').animate({opacity: 0}, function() {
			$.ajax(url)
			.done(function(data, textStatus) {
				$('#content').html(data);
				$('#content .content-block')
					.css({opacity: 0})
					.animate({opacity: 1})
					.removeClass('disappearing');
			})
			.fail(function(jqXHR, textStatus, errorThrown) {
				console.info("fail!");
			})
			.always(function() {
				// $('#page-wrap .logo-spinner').removeClass('active');
			});

			// Update URL
			window.history.pushState($activeItem.attr('href'), 'cruvoir', $activeItem.attr('href'));

			// Update sidebar
			$oldItem = $sidebar.find('.active');
			$activeItem.addClass('active');
			$oldItem.addClass('deactivated');
			setTimeout(function() { $oldItem.removeClass('deactivated').removeClass('active'); }, 300);

		});
	});
*/
}

function load_cart() {
  $("#cart-form").submit(function(e) {
    e.preventDefault();

    if ($('select[name="id_attribute"]').length != 0) {
      if ($('select[name="id_attribute"]', this).val() == null) {
        displayError("Please select a size.");
        return;
      }
    }

    var $that = $(this);
    $('input[type="submit"]', this)
      .attr("disabled", "disabled")
      .val("Please wait...");

    var data = $(this).serialize();
    data += "&ajax=1";
    $.post(
      $(this).attr("action"),
      data,
      function(data, textStatus, jqXHR) {
        $('input[type="submit"]', $that)
          .removeAttr("disabled")
          .val("Add to Cart");

        if (data.hasError) {
          displayError(data.errors[0]);
          return;
        }

        $(".product-added").slideDown();

        $("a.cart").text("Cart (" + data.nbTotalProducts + ")");
      },
      "json"
    );
  });
}

function displayError(html) {
  $("#header + div.alert").remove();
  $("#header").after('<div class="alert alert-danger">' + html + "</div>");
  $("html, body").scrollTop(0);
}

var loadingProducts = false;

function infinite_load_page(page, noAsync) {
  console.log("attempt to load page ", page);
  if (loadingProducts) return;

  if (page > parseInt($(".product-grid").data("maxpage"))) {
    return;
  }

  loadingProducts = true;

  console.log("actually loading ", page);

  $("#infinite-spinner").fadeIn();

  // var url = document.location.href.replace("#", "");
  var url = window.location.href.split("#")[0];
  if (!$(".product-grid").data("category")) {
    url = updateQueryStringParameter(url, "ajax_infinite", "1");
  } else {
    url = updateQueryStringParameter(url, "ajax", "1");
  }
  url = updateQueryStringParameter(url, "p", page);

  console.log(url);

  history.pushState(
    "",
    document.title + " Page " + page,
    window.location.pathname + window.location.search + "#page" + page
  );

  $('.product-grid').append('<div class="page-indicator" id="page'+page+'" style="width: 100%;    text-align: center; margin-right: 150px;">Page ' + page + '</div>');

  var async = !!!noAsync;

  return $.ajax(url, { 'async': async })
    .done(function(data) {
      $(".product-grid").append('<!-- page ' + page + ' -->' + data + '');
      loadingProducts = false;
    })
    .always(function() {
      $("#infinite-spinner").fadeOut();
      loadingProducts = false;
    });
}

var currentPage = 1;

function load_infinite() {
  // load current page
  var hash = window.location.hash;
  if (hash && hash.substr(0, 5) === "#page") {
    var pageString = hash.substr(5);
    var page = parseInt(pageString);

    if (page != NaN) {
      for (var i = 2; i < page; i++) {
        
        currentPage = i;
        infinite_load_page(i, true);
      }
    }
  }

  $("#infinite-show-more").click(function(e) {
    e.preventDefault();
    currentPage++;

    if (currentPage > parseInt($(".product-grid").data("maxpage"))) {
      $(this).fadeOut();
      return;
    }

    $(this).fadeOut();
    infinite_load_page(currentPage);
  });

  $(window).scroll(function() {
    // more products?
    if (currentPage > 1 && !loadingProducts) {
      if (
        $(window).scrollTop() + window.innerHeight + 300 >=
        $("body").height()
      ) {
        currentPage++;
        console.log("MORE! ", currentPage);
        infinite_load_page(currentPage);
      }
    }
  });

}

$(document).ready(function() {
  $("[data-placeholder]")
    .focusin(function() {
      $(this).attr("placeholder", "");
    })
    .focusout(function() {
      $(this).attr("placeholder", $(this).data("placeholder"));
    });

  // load_grid();

  load_intro();
  load_sidebar();
  load_ui();
  load_product_gallery();
  load_auth();
  load_checkout();
  load_footer();
  load_header();
  load_account();
  load_cart();

  load_infinite();

  $(window).bind("beforeunload", function() {
    $("#content").css("transition", "none").animate({ opacity: 0 });
    $("#page-wrap .logo-spinner").addClass("active");
  });
});


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
